export const SOCIAL_BUTTON_DEFAULT_CSS =
  'btn btn-social btn-block font-weight-bold px-9 py-4 my-3 font-size-3';
